$(function () {
    console.log('Hello World!');
    onloadlabelcheck();
});

//swap variant label - start
swaplabel = (evt) => {
    setTimeout(function () {
  
      //hide all variant label
      $(evt).parents('.product__info-container').find(".jsc-var-label").hide();
      $(evt).parents('.product__info-container').find(".jsc-var-label").each(function () {
        var datavarid = $(this).attr('data-label-id');
        //check each of variant that is equal to variant id then show
        if (datavarid == $(evt).closest('.product__info-container').find('input[name="id"]').val()) {
            $(this).show();
        }
      });
  
      $('.jsc-render-label-section').show();
      var hasLabel = false;
      $(evt).parents('.product__info-container').find(".jsc-label").each(function () {
        if($(this).is(":visible")){
          hasLabel = true;
        }
      });
      if (hasLabel) {
        $('.jsc-render-label-section').show();
      }else{
        $('.jsc-render-label-section').hide();
      }
  
    }, 10);
};
  
onloadlabelcheck = () => {
    $('.product__info-container').each(function () {
        var hasLabel = false;
        $(this).find(".jsc-label").each(function () {
        if($(this).is(":visible")){
            hasLabel = true;
        }
        });
        if (hasLabel) {
        $(this).find('.jsc-render-label-section').show();
        }else{
        $(this).find('.jsc-render-label-section').hide();
        }
    });
};
//swap variant label - end